import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { RtrButtonComponent } from '@rtr-factory/ui/button';
import { DialogWrapperComponent } from '@rtr-factory/ui/dialog';
import { SystemVersionEntry } from 'rio-models';

@Component({
  selector: 'app-system-versions-dialog',
  imports: [DialogWrapperComponent, TranslateModule, RtrButtonComponent],
  templateUrl: './system-versions-dialog.component.html',
  styleUrl: './system-versions-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemVersionsDialogComponent {
  dialogRef = inject(MatDialogRef<SystemVersionsDialogComponent>);

  versions = inject<SystemVersionEntry[]>(MAT_DIALOG_DATA);

  close() {
    this.dialogRef.close();
  }
}
